import { Pipe, PipeTransform, Inject } from '@angular/core';

@Pipe({ name: 'mytranslate' })
export class TranslatePipe implements PipeTransform {
    constructor(@Inject('$translate') private $translate: any) {
    }

    public async transform(value: string | string[]): Promise<string | { [id: string]: string }> {
        return typeof value === 'string'
            ? (await this.translate([value]))[value]
            : await this.translate(value);
    }

    private async translate(keys: string[]): Promise<{ [id: string]: string }> {
        return await this.$translate(keys);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/pipes/translate.pipe.ts